<script>
import CoreComponent from '../../../../../../../dow-platform/ui.frontend/src/dow-platform/components/core/CoreComponent.vue'

export default {
    extends: CoreComponent,
    
    data() {
        return {
            observer: null,
            isScrolledPast: false,
            closed: false
        }
    },  

    methods: {
        createSentinel(target) {
            let sentinel = document.createElement("div");
            sentinel.classList.add("cmp-sticky-banner__sentinel");
            sentinel.style.top = `${target}px`;
            document.body.appendChild(sentinel);
            return sentinel;
        },

        disconnectObserver() {
            if (this.observer) { this.observer.disconnect(); }
        },

        closeBanner() {
            this.closed = true;
            this.cmpEl.classList.remove("cmp-sticky-banner--visible");
        },  

        initObserver()  {

            const targetValue = this.cmpEl.dataset.bannerTarget;
            const isNum = !isNaN(targetValue) && targetValue !== '';
            const target = isNum ? this.createSentinel(targetValue) : document.getElementById(targetValue);

            if (!target) {
                this.cmpEl.classList.add("cmp-sticky-banner--visible");
                return;
            }

            const options = {
                rootMargin: '0px',
                threshold: 0
            };

            this.observer = new IntersectionObserver(([entry]) => {
                if (!this.closed) {
                    this.isScrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                    this.cmpEl.classList.toggle("cmp-sticky-banner--visible", this.isScrolledPast);
                }
            }, options);

            this.observer.observe(target);
        },
    },

    mounted() {
        if (!this.cmpEl) return;
        if (this.cmpEl.classList.contains("cmp-sticky-banner--fixed")) {
            this.initObserver();
            const closeButton = this.cmpEl.querySelector(".cmp-sticky-banner__close");
            closeButton.addEventListener("click", this.closeBanner.bind(this));
        }
    },

    beforeDestroy() {
        this.disconnectObserver();
    }
}
</script>

<style lang="scss">
@import './sticky-banner.scss';
</style>